import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from "@angular/router";
import { constants } from "../../../utils/constants";
import { AuthService } from '../../../services/auth.service';
import { Role } from 'src/app/models/role.model';
import { UserService } from '../../../services/user.service';
import { IErrorAlert } from '../../../interfaces/error.interface';
import { User } from '../../../models/user.model';
import { TranslatorService } from '../../../services/translator.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import helpers from 'src/app/utils/helpers';

@Component({
  selector: "app-create-user",
  templateUrl: "./create-user.component.html",
  styleUrls: ['../admin.component.css']
})
export class CreateUserComponent implements OnInit {
  constants: any = constants;
  helpers = helpers;
  capsWarning = { ...constants.alerts.capslock, width: 'auto'}
  capslockOn: boolean;
  userManagmentUrl: string = '/pages/admin/user-management';
  
  dropdownSettings: IDropdownSettings = {};
  touchedRoles = false;

  docTypes: any[];
  maxLengthDoc: number;
  roles: Role[];
  loading: boolean = true;
  error: IErrorAlert;
  form: FormGroup;

  constructor(private _fb: FormBuilder, private _router: Router, public _auth: AuthService, public _user: UserService, public _translator: TranslatorService) {
    if (!this._auth.user.isExecutive()) {
      this.userManagmentUrl = '/pages/home/user-management'
    }
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'uri',
      textField: 'fullName',
      itemsShowLimit: 3,
      allowSearchFilter: false,
      enableCheckAll: false,
    };
  }

  ngOnInit(): void {
    this.initForm();
    this._user.getRoles().subscribe(
      (roles: Role[]) => {
        this.roles = roles;
        this.loading = false;
      },
      (err) => {
        this.error = {...err, width: 'auto'};
        this.form.controls["role"].disable(),
        this.loading = false;
      }
    )
    this._translator.getDocTypes().subscribe(
      (docTypes: any) => {
        this.docTypes = docTypes;
        this.loading = false;
      },
      (err) => {
        this.error = {...err, width: 'auto'};
        this.form.controls["docType"].disable(),
        this.loading = false;
      }
    )
  }

  create() {
    this.loading = true;
    const user = new User({
      firstName: this.form.controls["firstName"].value,
      lastName: this.form.controls["lastName"].value,
      docType: this.form.controls["docType"].value,
      docNumber: this.form.controls["docNumber"].value,
      email: this.form.controls["email"].value,
      phone: this.form.controls["phone"].value,
      charge: this.form.controls["charge"].value,
      roles: this.form.controls["role"].value,
    })
    this._user.insert(user, this._auth.user).subscribe(
      () => this._router.navigate(["/pages/admin/create-success"]),
      (err) => {
        this.error = {...err, width: 'auto'};
        this.loading = false;
      }
    )
  }

  private initForm() {
    this.form = this._fb.group({
      firstName: [
        "",
        [
          Validators.required,
          Validators.maxLength(20),
          Validators.pattern(constants.validations.alphabetic.pattern),
        ],
      ],
      lastName: [
        "",
        [
          Validators.required,
          Validators.maxLength(20),
          Validators.pattern(constants.validations.alphabetic.pattern),
        ],
      ],
      docType: ["", [Validators.required]],
      docNumber: [
        { value: "", disabled: true },
        Validators.required
      ],
      email: [
        "",
        [
          Validators.required,
          Validators.pattern(constants.validations.email.pattern),
        ],
      ],
      phone: ["", [Validators.required, Validators.minLength(8)]],
      charge: [
        "",
        [
          Validators.required,
          Validators.maxLength(60),
          Validators.pattern(constants.validations.alphabetic.pattern),
        ],
      ],
      role: ["", [Validators.required]],
    });
    this.helpers.initFormListeners(this.form);
  }

  onChange(event: any) {
    let control = this.form.controls["docNumber"];
    this.maxLengthDoc = helpers.onChangeDocType(event, control);
  }

  onDropDownClose() {
    if (this.touchedRoles) {
      this.form.get('role').markAsTouched()
    }
  }

  onClickSelect() {
    this.touchedRoles = true;
  }

  

  onClickImputTel(e):void {
    
    if(e.target.selectionStart === 0){
      e.target.setSelectionRange(6,6);
      
    }
       
   
  }

}
